/* eslint-disable react/prop-types */
/* eslint-disable no-undef */
import { Field, FieldArray, Form as FormikForm, Formik } from 'formik';
import { cloneDeep } from 'lodash';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import NButton from '../../components/inputs/NButton';
import NInput from '../../components/inputs/NInput';
import { successToaster } from '../../components/toaster/Toaster';
import useAuthHook from '../../hooks/custom-hooks/useAuthHook';
import useSettingsAPI from '../../hooks/network/useSettingsAPI';
import { loginSettingsValidation } from '../../validations/validation';

const formInitialValues = {
  sliderImage: null,
  sliderImageUrl: '',
  textColor: '#FFF',
  slides: [{ title: '', desc: '' }],
};

export function LoginSettings() {
  const [formValues, setFormValues] = useState(formInitialValues);

  const { saveConfig, saveFile, getConfigByGroupAndKey, isLoading } = useSettingsAPI();
  const { isCustomerAdmin, userRole } = useAuthHook();
  const navigate = useNavigate();

  useEffect(() => {
    if (!userRole || (userRole && isCustomerAdmin)) {
      navigate('/');
    }
    setFormValues(formInitialValues);
    getLoginSettings();
  }, []);

  const getLoginSettings = async () => {
    try {
      const config = await getConfigByGroupAndKey('loginSettings', 'loginSettings');
      if (!config?.value) return;
      const parsedData = JSON.parse(config?.value);
      setFormValues({
        ...formInitialValues,
        textColor: parsedData?.textColor,
        sliderImageUrl: parsedData?.sliderImageUrl,
        slides: parsedData?.slides,
      });
    } catch {}
  };

  const handleFormSubmit = async (values) => {
    try {
      const url = process.env.REACT_APP_API_ENDPOINT;
      const formData = cloneDeep(values);

      if (values?.sliderImage) {
        const saveFileResponse = await saveFile({ file: values?.sliderImage });
        if (saveFileResponse?.success) {
          formData.sliderImageUrl = `${url}/${saveFileResponse?.data}`;
        }
      }

      delete formData.sliderImage;

      const payload = {
        group: 'loginSettings',
        key: 'loginSettings',
        value: JSON.stringify(formData),
      };

      const saveConfigResponse = await saveConfig(payload);
      if (saveConfigResponse) {
        successToaster('Setting Saved');
        getLoginSettings();
      }
    } catch {}
  };

  function MyInput({ field, form, ...props }) {
    return (
      <div className='w-full'>
        <NInput
          multiline
          rows={5}
          className='w-full'
          label={props?.label}
          placeholder={props?.placeholder}
          name={field?.name}
          value={field?.value}
          onChange={field?.onChange}
          onBlur={field?.onBlur}
          error={form?.errors?.[field?.name] && form?.touched?.[field?.name]}
          helperText={
            form?.errors?.[field?.name] && form?.touched?.[field?.name]
              ? form?.errors?.[field?.name]
              : ''
          }
        />
      </div>
    );
  }

  return (
    <Formik
      initialValues={formValues}
      validationSchema={loginSettingsValidation}
      onSubmit={(values, formikBag) => {
        handleFormSubmit(values, formikBag);
      }}
      enableReinitialize
    >
      {({ handleSubmit, handleChange, handleBlur, setFieldValue, values }) => (
        <FormikForm className='' autoComplete='off' onSubmit={handleSubmit}>
          <div className='w-ful mt-5 h-[calc(100vh-100px)] rounded-lg bg-white px-5 pb-10 break:mx-20 break:px-10 lgMax:overflow-auto'>
            <div className='mb-5 border-b border-solid border-[#707070] py-4 break:mb-10'>
              <p className='font-semibold'> Login Screen Settings</p>
            </div>
            <div>
              <div className='mb-8 flex flex-col items-start justify-start gap-5 break:flex-row break:items-center'>
                <div>
                  <h2 className='text-sm font-medium break:text-lg maclg:text-xl'>Slider Image</h2>
                </div>
                <div>
                  <input
                    className='text-sm break:text-lg'
                    onBlur={handleBlur}
                    onChange={(e) => {
                      setFieldValue('sliderImage', e?.target?.files?.[0]);
                    }}
                    type='file'
                    accept='image/*'
                    name='sliderImage'
                  />
                </div>
              </div>
              <div className='mb-8 flex flex-col items-start justify-start gap-5 break:flex-row break:items-center'>
                <div>
                  <h2 className='text-sm font-medium break:text-lg maclg:text-xl'>
                    Uploaded Image
                  </h2>
                </div>
                <div>
                  <img width={300} height={300} src={values?.sliderImageUrl} alt='img' />
                </div>
              </div>
              <div className='mb-8 flex flex-col items-start justify-start gap-5 break:flex-row break:items-center'>
                <div>
                  <h2 className='text-sm font-medium break:text-lg maclg:text-xl'>Text Color</h2>
                </div>
                <div>
                  <input
                    onBlur={handleBlur}
                    onChange={handleChange}
                    type='color'
                    id='textColor'
                    name='textColor'
                    value={values?.textColor}
                  />
                </div>
              </div>
              <div>
                <div className=''>
                  <div className=''>
                    <h2 className='mb-6 text-sm font-medium break:text-lg maclg:text-xl'>
                      Login Slider Text
                    </h2>
                    <div className='w-full'>
                      <FieldArray
                        name='slides'
                        render={(arrayHelpers) => (
                          <div className=''>
                            {values?.slides?.map((av, index) => (
                              <div
                                key={`slides${index}`}
                                className='relative mb-2 flex w-full flex-col break:flex-row break:gap-4 last:breakMax:mb-8'
                              >
                                <div className='mb-5 w-full break:mb-10'>
                                  <Field
                                    placeholder='Title'
                                    label='Title'
                                    name={`slides[${index}].title`}
                                    component={MyInput}
                                  />
                                </div>
                                <div className='mb-8 w-full break:mb-10'>
                                  <Field
                                    placeholder='Description'
                                    label='Description'
                                    name={`slides[${index}].desc`}
                                    component={MyInput}
                                  />
                                </div>
                                <div className='absolute bottom-0 right-0 flex cursor-pointer items-center justify-end'>
                                  <div className='flex flex-row items-center justify-center gap-4'>
                                    {values?.slides?.length > 1 && (
                                      <div>
                                        <div className='text-sm font-semibold text-red-700 hover:underline break:text-lg'>
                                          <span onClick={() => arrayHelpers.remove(index)}>
                                            Remove
                                          </span>
                                        </div>
                                      </div>
                                    )}
                                    {values.slides.length - 1 === index && (
                                      <div>
                                        <div className='text-sm font-semibold text-nblue hover:underline break:text-lg'>
                                          <span
                                            onClick={() =>
                                              arrayHelpers.push({
                                                title: '',
                                                desc: '',
                                              })
                                            }
                                          >
                                            Add More
                                          </span>
                                        </div>
                                      </div>
                                    )}
                                  </div>
                                </div>
                              </div>
                            ))}
                          </div>
                        )}
                      />
                    </div>
                    <div className='flex items-center justify-center'>
                      <NButton
                        onClick={() => {
                          handleSubmit();
                        }}
                        variant='Ncontained'
                        isLoading={isLoading}
                      >
                        Save Settings
                      </NButton>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </FormikForm>
      )}
    </Formik>
  );
}
